import { useContext } from 'react';
import { NotificationLoadingContext } from '../providers/NotificationLoadingProvider';

function useNotificationLoading() {
  const { alert, addAlert, removeAlert, loading, setLoading } = useContext(NotificationLoadingContext);
  return { alert, addAlert, removeAlert, loading, setLoading };
}

export default useNotificationLoading;